import currencies from "currencies.json"
import currenciesHistory from "currencies_history.json"
import Dinero, { Currency } from "dinero.js"
import { ISO4217, ISO8601Date, ISO8601DateTime } from "modules/common/types"

export const getCurrencyPrecision = (currency: any, dateTime: ISO8601DateTime | ISO8601Date) => {
    const currencyInfo = currencies[currency as ISO4217]
    const currencyInfoHistory = currenciesHistory[currency as keyof typeof currenciesHistory]

    let precision = 2

    if (currencyInfo) {
        precision = currencyInfo.exp as unknown as number
    }

    if (currencyInfoHistory) {
        const valueDateTime = new Date(dateTime)
        const beforeDateTime = new Date(currencyInfoHistory.before_date_time)

        if (valueDateTime < beforeDateTime) {
            precision = currencyInfoHistory.exp as unknown as number
        }
    }

    return precision
}

// TQL amount modifiers are minor units. The UI, the URL and anything typed
// are major units, so the query converts once on its way to the API.
export const tqlToMinorUnits = (query: string) => {
    // ponytail: first currency wins; mixed exponents in one query have no right answer client-side
    const currency = query.match(/\bcurrency:([a-z]{3})\b/i)?.[1] ?? ""
    const exp = getCurrencyPrecision(currency.toUpperCase(), new Date().toISOString())
    const toMinor = (n: string) => String(Math.round(Number(n.replace(",", ".")) * 10 ** exp))

    return query.replace(
        /\b(min|max):(\S+)/g,
        (_, modifier, value) => `${modifier}:${value.replace(/\d+(?:[.,]\d+)?/g, toMinor)}`
    )
}

export const getAmount = (value: number, currency: any, date?: any) => {
    if (!date) {
        date = new Date().toISOString()
    }
    const precision = getCurrencyPrecision(currency, date)

    const amount = Dinero({
        amount: value,
        currency: currency as Currency,
        precision,
    })

    return amount.toUnit()
}
